import gql from "graphql-tag";

const GetShippersSavedShippingRequest = gql`
  query($user_id: String!) {
    getSavedShippingRequests(user_id: $user_id) {
      id
      data
      created_at
      updated_at
    }
  }
`;

export default GetShippersSavedShippingRequest;
